import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=edc83704&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edc83704')) {
      api.createRecord('edc83704', component.options)
    } else {
      api.reload('edc83704', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=edc83704&", function () {
      api.rerender('edc83704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23Fsngc5EpV7S/JS/comp/ImgFallback.vue"
export default component.exports